import type { PortfolioItemProps } from '../PortfolioItem';
import { assertNever } from '~/Partials/Utils/typeUtils';

export const getTypeIcon = (type: PortfolioItemProps['item']['type']) => {
    switch (type) {
        case 'audio':
            return 'headphones';
        case 'video':
            return 'film';
        case 'image':
            return undefined;
        default:
            assertNever(type);
    }
};

export const getActionIcon = (type: PortfolioItemProps['item']['type']) => {
    switch (type) {
        case 'audio':
        case 'video':
            return 'play-circle';
        case 'image':
            return undefined;
        default:
            assertNever(type);
    }
};
